var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotWorking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "orangefill",
    d: "M-14832.9-9692.178l8.48,8.434-8.48,8.651-8.385-8.651Z",
    transform: "translate(14841.894 9692.723)",
    fill: "#ed7000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "orangefill",
    d: "M17.425,7.613,10.387.575a1.96,1.96,0,0,0-2.774,0L.575,7.613a1.962,1.962,0,0,0,0,2.774l7.038,7.038a1.96,1.96,0,0,0,2.774,0l7.038-7.038A1.96,1.96,0,0,0,17.425,7.613Zm-.8,1.979L9.592,16.63a.838.838,0,0,1-1.184,0L1.37,9.592a.838.838,0,0,1,0-1.184L8.408,1.37a.838.838,0,0,1,1.184,0L16.63,8.408a.838.838,0,0,1,0,1.184Z",
    transform: "translate(-0.001 0)",
    fill: "#ed7000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "whitefill",
    d: "M9.347,10.832l.339-3.761V4.5H8.314V7.071l.339,3.761Z",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "whitefill",
    width: 1.495,
    height: 1.527,
    transform: "translate(8.252 11.973)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotWorking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/not-working.132eca024ab65744b6407d9d1fb66632.svg";